<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getApplyList"
      ref="selfExtraSignList"
      hide-title-search
      @click:row="getDetails($event.item)"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      clickable>
      <template slot="title">
        <span class="pl-2 pr-4">个人申请记录（补卡）</span>
      </template>
      <!--<template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn icon :disabled="item.firstAuditStatus+''!=='0'" @click="review(item)">
            <v-icon>{{$vuetify.icons.edit}}</v-icon>
          </v-btn>
        </td>
      </template>-->
    </l-data-table>
  </l-layout>
</template>

<script>
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  import {time} from "../../../ladmin/utils/time";
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '已通过';
      case '2':return '已拒绝';
      case '0':return '待审核';
      case '-1':return 'N/A';
      default:return v;
    }
  }
  function transType(v) {
    switch (v+'') {
      case "0":return "普通类型"
      case "1":return "指标异常"
    }
  }
  export default {
    name: "firstReviewList",
    components: {LDataTable},
    data(){
      return {
        header:[
          {text:'申请时间',value:'creationTime',sortable:false,align:'left',placeholder:'N/A',f:(v)=>time.stringify(v)},
          {text:'二级单位审核状态',value:'firstAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'二级单位审核评语',value:'firstAuditComment',sortable:false,align:"left",maxWidth: '6em', tooltip: true,placeholder:'N/A'},
          {text:'校医院审核状态',value:'medicineAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'校医院审核评语',value:'medicineAuditComment',sortable:false,align:"left",maxWidth: '6em', tooltip: true,placeholder:'N/A'},
          {text:'人事处审核状态',value:'secondAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'人事处审核评语',value:'secondAuditComment',sortable:false,align:"left",maxWidth: '6em', tooltip: true,placeholder:'N/A'},
          {text:'',value:'',sortable:false,align:'left'}
        ],
        selected:[],
        loading:false
      }
    },
    computed:{
      curOrg(){
        return this.$store.state.login.currentOrg
      }
    },
    methods:{
      getLoginInfo(){
        return JSON.parse(sessionStorage.getItem('loginInfo'))
      },
      async getApplyList({pagination}){
        let filter = [
          {key:'creator',value:this.getLoginInfo().id}
        ]
        let {items,amount} = await this.$store.dispatch('school/getExtraSignList',{pagination:pagination,filter:filter})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
            item.medicineAuditStatus = '-1'
          }
        }
        return {items:items,amount:amount}
      },
      getDetails(item){
        this.$router.push({name:'signApplyDetail',
          query:{
            id:item.id,
            status:'readonly'
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
